'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.transferAcknowledgements = undefined;

var _reactIntl = require('react-intl');

var acknowledgements = (0, _reactIntl.defineMessages)({
    ACKNOWLEDGED: {
        'id': 'formOverrides.acknowledgements.ACKNOWLEDGED',
        'defaultMessage': 'Acknowledged.'
    }
});

var transferAcknowledgements = exports.transferAcknowledgements = (0, _reactIntl.defineMessages)({
    ACKNOWLEDGED: {
        'id': 'formOverrides.transferAcknowledgements.ACKNOWLEDGED',
        'defaultMessage': 'I do not require a transfer.'
    }
});

exports.default = acknowledgements;


//////////////////
// WEBPACK FOOTER
// ./app/metadata/forms/formOverrides/acknowledgements.js
// module id = 1379
// module chunks = 0